export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  setNewOutlet(state, { payload }) {
    state.outlets = [...state.outlets, ...[payload]];
  },
  delProperty(state, { property }) {
    state.outlets = state.outlets.filter(el => el.id !== property);
  },
};
